const counters = {};
const uniqueId = (prefix) => {
  counters[prefix] = (counters[prefix] || 0) + 1;
  return `${prefix}${counters[prefix]}`;
};

export { uniqueId };
//# sourceMappingURL=uniqueId.es.js.map
